import {
  Box,
  BoxProps,
  Button,
  Flex,
  Heading,
  Icon,
  List,
  ListItem,
  OrderedList,
} from '@chakra-ui/react';
import { IoClose } from '@react-icons/all-files/io5/IoClose';
import { FC, MutableRefObject, useState } from 'react';
import scrollToElement from '../../utils/scrollToElement';
import { IoChevronDown } from '@react-icons/all-files/io5/IoChevronDown';

type TableOfContentsProps = BoxProps & {
  links: Array<{
    title: string;
    anchor: string;
  }>;
  ref?: any;
  onClick?: () => void;
  onClose?: () => void;
  showClose?: boolean;
  isSticky?: boolean;
  mobileCutted?: boolean;
};

export const TableOfContents: FC<TableOfContentsProps> = ({
  links,
  onClick,
  onClose,
  showClose,
  isSticky,
  mobileCutted,
  ...props
}) => {
  const [showAll, setShowAll] = useState(false);

  return (
    <Box layerStyle="shadowBox" pos="relative" {...props}>
      {showClose && (
        <Button
          variant="ghost"
          pos="absolute"
          top="5px"
          right={0}
          zIndex={14}
          onClick={onClose}
        >
          <Icon as={IoClose} />
        </Button>
      )}
      <Heading as="div" variant="boxTitle">
        <Box as="span">Inhaltsverzeichnis</Box>
      </Heading>
      <List
        pt={3}
        color="primaryDark"
        maxH={
          isSticky
            ? {
                base: 'calc(100vh - 8rem)',
                md: 'none',
              }
            : 'none'
        }
        overflowY={isSticky ? 'auto' : 'visible'}
      >
        {links.map((link, i) => (
          <ListItem
            key={link.anchor}
            display={{
              base: mobileCutted && i >= 3 && !showAll ? 'none' : 'list-item',
              md: 'list-item',
            }}
          >
            <a
              href={`#${link.anchor}`}
              onClick={(e) => {
                e.preventDefault();

                scrollToElement(`#${link.anchor}`);
                onClick && onClick();
              }}
            >
              <Box
                display="block"
                as="span"
                py={1}
                _hover={{
                  color: 'primaryDarker',
                  transition: 'color .2s',
                }}
              >
                {i + 1}. {link.title}
              </Box>
            </a>
          </ListItem>
        ))}
      </List>
      {!showAll && mobileCutted && (
        <Flex
          justifyContent="center"
          mt={3}
          pt={3}
          borderTop="1px solid"
          borderColor="accent"
        >
          <Button
            size="sm"
            variant="outlineBlue"
            onClick={() => setShowAll(true)}
          >
            Alle Inhalte <Icon as={IoChevronDown} />
          </Button>
        </Flex>
      )}
    </Box>
  );
};
